import * as React from "react";
import { filterItems } from "../infinite-utils/infinite-utils-search";
import { IMatchHOCProps } from "../infinite-interface";

export class MatchHOC extends React.PureComponent<IMatchHOCProps, any> {
    render() {
        return this.props.children(this.searchItems());
    }

    private searchItems() {
        const { items, searchableFields, searchTerm, filters } = this.props;
        if (!items || !(searchTerm || filters)) {
            return items;
        }
        return filterItems(items, searchableFields, filters, searchTerm);
    }
}
